/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_Link_SecurityInputs */

const en_landing_footer_link_security = /** @type {(inputs: Landing_Footer_Link_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Security & sovereignty`)
};

/**
* | output |
* | --- |
* | "Security & sovereignty" |
*
* @param {Landing_Footer_Link_SecurityInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_footer_link_security = /** @type {((inputs?: Landing_Footer_Link_SecurityInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_Link_SecurityInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_footer_link_security(inputs)
});